<style>/*
    :root {
        --color-red: #e63946;
        --color-teal: #06b6d4;
        --color-blue: #1e3a8a;
        --color-dark: #111827;
        --color-muted: #4b5563;
        --color-light: #f9fafb;
        --radius: 12px;
        --shadow: 0 4px 12px rgba(0, 0, 0, .05);
    }

    * { box-sizing: border-box; margin: 0; padding: 0; }

    body {
        font-family: Arial, sans-serif;
        line-height: 1.6;
        color: var(--color-dark);
        background: #fff;
    }

    !* Layout *!
    section { padding: 5rem 2rem; }
    .container { max-width: 1200px; margin: 0 auto; }
    .center { text-align: center; }
    .grid { display: grid; gap: 2rem; }
    .flex { display: flex; }
    .items-center { align-items: center; }
    .justify-between { justify-content: space-between; }
    .justify-center { justify-content: center; }
    .gap-1 { gap: 1rem; }
    .gap-2 { gap: 2rem; }
    .mt-1 { margin-top: 1rem; }
    .mb-05 { margin-bottom: .5rem; }
    .mb-1 { margin-bottom: 1rem; }
    .mb-15 { margin-bottom: 1.5rem; }
    .mb-2 { margin-bottom: 2rem; }
    .mb-25 { margin-bottom: 2.5rem; }
    .mb-3 { margin-bottom: 3rem; }

    !* Header *!
    header {
        border-bottom: 1px solid #eee;
        background: #fff;
        position: sticky;
        top: 0;
        z-index: 50;
    }
    .header-inner {
        max-width: 1200px;
        margin: 0 auto;
        padding: 1rem 2rem;
    }
    nav { display: flex; gap: 2rem; }
    nav a {
        text-decoration: none;
        color: var(--color-muted);
        font-weight: 500;
        transition: .2s;
    }
    nav a:hover { color: var(--color-dark); }

    !* Logo box *!
    .logo-box {
        background:#f3f4f6;
        padding:.3rem .8rem;
        border-radius:8px;
    }
    .logo { height: 28px; }
    .footer-logo { height: 30px; }

    !* Buttons *!
    .btn {
        padding: .75rem 1.5rem;
        border-radius: var(--radius);
        font-weight: 500;
        cursor: pointer;
        transition: .2s;
        border: none;
    }
    .btn-primary { background: var(--color-dark); color: #fff; }
    .btn-primary:hover { background: #000; }
    .btn-secondary { background: #fff; border: 1px solid var(--color-dark); color: var(--color-dark); }
    .btn-light { background: #fff; color: var(--color-blue); }
    .btn-outline-white { background: transparent; border: 1px solid #fff; color: #fff; }
    .btn-lg { min-width: 220px; font-size: 1rem; }
    .btn-md { min-width: 180px; font-size: 1rem; }

    .btn-group { display:flex; gap:1rem; flex-wrap:wrap; }

    !* Badges *!
    .badge {
        display: inline-flex;
        align-items: center;
        gap: .4rem;
        font-size: .85rem;
        font-weight: 500;
        border-radius: 9999px;
        padding: .3rem 1rem;
    }
    .badge-blue { background:#e0f2fe; color:#0369a1; }
    .badge-red { background:#dc2626; color:#fff; }
    .badge-light-red { background:#fee2e2; color:#b91c1c; }
    .badge-live { position:absolute; top:10px; right:-20px; }
    .badge-popular, .badge-best {
        position: absolute; top: -12px; left: 50%; transform: translateX(-50%);
        color: #fff; font-size: .8rem; font-weight: 600; padding: .3rem 1rem; border-radius: 9999px;
    }
    .badge-popular { background: var(--color-teal); }
    .badge-best { background: #f59e0b; }

    !* Hero *!
    .hero { display:grid; grid-template-columns:1fr; gap:2rem; align-items:center; }
    @media (min-width: 900px) {
        .hero { grid-template-columns:1fr 1fr; }
    }
    .hero h1 {
        font-size: 2.75rem; font-weight: 800; line-height: 1.2; margin: 1rem 0;
        background: linear-gradient(to right, #9b2c2c, #374151, #0891b2);
        -webkit-background-clip: text; color: transparent;
    }
    .hero p { margin-bottom: 1rem; color: var(--color-muted); }
    .hero ul { list-style: none; margin: 1rem 0; }
    .hero li { display:flex; align-items:center; gap:.5rem; margin:.3rem 0; }
    .hero li span { color: var(--color-teal); }

    .hero-img { position: relative; }
    .hero-img img { width:100%; border-radius:16px; box-shadow:0 10px 30px rgba(0,0,0,0.1); }

    !* Generic sections *!
    .section-light { background: var(--color-light); }
    .section-white { background: #fff; }
    .section-gradient {
        background: linear-gradient(135deg,#1e3a8a,#06b6d4);
        color:#fff; text-align:center; padding:6rem 2rem; position:relative; overflow:hidden;
    }
    .gradient-text {
        background:linear-gradient(to right,#9b2c2c,#374151,#0891b2);
        -webkit-background-clip:text; color:transparent;
    }

    !* Features *!
    .features-grid {
        display:grid; grid-template-columns:repeat(auto-fit, minmax(280px, 1fr)); gap:2rem;
    }
    .card {
        background:#fff; border-radius:var(--radius); padding:2rem; box-shadow:var(--shadow); text-align:center;
        transition:.3s;
    }
    .card h3 { margin:.5rem 0; font-size:1.125rem; font-weight:700; }
    .card p { color:var(--color-muted); font-size:.95rem; }
    .card-hover:hover { transform: translateY(-6px); box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08); }

    .icon-box {
        width:64px; height:64px; margin:0 auto 1rem; border-radius:var(--radius);
        background: linear-gradient(to bottom, #e0f2f1, #fff);
        display:flex; align-items:center; justify-content:center; font-size:1.5rem;
    }

    !* CTA section card *!
    .section-card {
        background:linear-gradient(to right,#f3f4f6,#e0f2fe);
        border-radius:20px; padding:3rem 2rem; text-align:center; box-shadow:0 6px 20px rgba(0,0,0,0.06);
    }

    !* Partner grid *!
    .partner-grid {
        display:grid; grid-template-columns:repeat(auto-fit,minmax(150px,1fr));
        gap:2rem; align-items:center; justify-items:center;
    }
    .partner-card {
        background:#f9fafb; border-radius:16px; box-shadow:0 4px 10px rgba(0,0,0,.05);
        padding:1.5rem; transition:.3s;
    }
    .partner-logo { max-height:40px; width:auto; display:block; }

    !* Pricing *!
    .toggle-wrapper {
        display:inline-flex; background:#f9fafb; border-radius:9999px; padding:.3rem;
        box-shadow: inset 0 1px 3px rgba(0,0,0,0.05);
    }
    .toggle-btn {
        border:none; background:transparent; padding:.6rem 1.5rem; border-radius:9999px;
        font-size:1rem; font-weight:500; color:#6b7280; cursor:pointer; transition: all .2s ease;
        display:flex; align-items:center; gap:.5rem;
    }
    .toggle-btn.active { background:#fff; color:#111827; font-weight:600; box-shadow:0 2px 6px rgba(0,0,0,0.05); }
    .discount { background:#06b6d4; color:#fff; font-size:.75rem; padding:.2rem .6rem; border-radius:9999px; font-weight:600; }

    .price-card { padding:2rem; text-align:center; display:flex; flex-direction:column; justify-content:space-between; position:relative; }
    .price-label { font-size:1.75rem; font-weight:800; margin:1rem 0; }
    .price { font-size:2rem; font-weight:800; margin:1rem 0; }
    .price span { font-size:.9rem; font-weight:400; }
    .price-card ul { list-style:none; padding:0; margin:1.5rem 0; text-align:left; }

    .border-teal { border:2px solid var(--color-teal); }
    .btn-teal { background: var(--color-teal); color:#fff; }

    !* Text helpers *!
    .text-muted { color: var(--color-muted); }
    .text-sm { font-size:.85rem; }
    .text-red { color: var(--color-red); }
    .text-teal { color: var(--color-teal); }
    .text-blue { color: var(--color-blue); }

    !* Security badges bar *!
    .security-badges {
        display:flex; flex-wrap:wrap; justify-content:center; gap:1.5rem; font-size:.95rem;
        background:#fff; padding:1rem 1.5rem; border-radius:12px; box-shadow:0 4px 10px rgba(0,0,0,0.05);
    }

    !* Links *!
    .link { text-decoration:none; }
    .link-teal { color: var(--color-teal); text-decoration: none; }

    !* Contact *!
    .contact-grid {
        max-width:1100px; margin:auto; display:grid; grid-template-columns:1fr 1fr; gap:2rem;
    }
    .contact-card { padding:2rem; text-align:left; }
    .contact-info { margin-bottom:1rem; display:flex; align-items:flex-start; gap:.8rem; }
    .contact-icon { background:#fee2e2; color:#b91c1c; padding:.6rem; border-radius:12px; }
    .contact-managers { display:flex; flex-direction:column; gap:1rem; }
    .manager { display:flex; align-items:center; gap:.8rem; }
    .manager img { width:40px; height:40px; border-radius:50%; }

    .form-label { font-weight:600; display:block; }
    .form-field {
        margin:.5rem 0 1rem; width:100%; padding:.9rem; border:1px solid #d1d5db; border-radius:12px;
    }
    .form-textarea {
        margin:.5rem 0 1.5rem; width:100%; padding:.9rem; border:1px solid #d1d5db; border-radius:12px;
    }
    .form-btn {
        width:100%; background:#111827; color:#fff; padding:1rem; border-radius:12px; font-weight:600; border:none;
    }

    !* Footer *!
    footer { background:#f9fafb; padding:2rem 2rem; border-top:1px solid #e5e7eb; }
    .footer-inner {
        max-width:1200px; margin:auto; display:flex; flex-wrap:wrap; align-items:center; justify-content:space-between; gap:1rem;
        font-size:.9rem; color:#4b5563;
    }
    .footer-links { display:flex; flex-wrap:wrap; gap:1.5rem; align-items:center; }
    .footer-link { text-decoration:none; color:#4b5563; transition:.2s; }
*/</style>

<header>
    <div class="header-inner flex items-center justify-between">
        <div class="logo-box">
            <img class="logo" src="https://imzaflow.de/lovable-uploads/f6a771ae-6ce0-46a7-9854-a4ad61ca3ddc.png" alt="IMZAFLOW Logo">
        </div>
        <nav>
            <a href="{{basePath}}#start">Start</a>
            <a href="{{basePath}}#loesung">Lösung</a>
            <a href="{{basePath}}#vorteil">Vorteil</a>
            <a href="{{basePath}}#fokus">Fokus</a>
            <a href="{{basePath}}#referenzen">Referenzen</a>
            <a href="{{basePath}}#preise">Angebot</a>
            <a href="{{basePath}}#kontakt">Kontaktformular</a>
        </nav>
        <div>
            <button class="btn btn-primary" (click)="navigate('/','')">Kostenlos testen</button>
        </div>
    </div>
</header>

<!-- Hero -->
<section id="start" class="hero container">
    <div>
        <span class="badge badge-blue">✔ eIDAS 2.0 Ready – Zukunftssicher</span>
        <h1>Multifunktionale<br>Digitale Signatur-Plattform</h1>
        <p>Elektronische Unterschriften für jeden Einsatzbereich mit wenigen Klicks erstellt.</p>
        <ul>
            <li><span>✔</span> Verträge zügig digital abgeschlossen</li>
            <li><span>✔</span> Verschiedene Signaturformate eingebunden</li>
            <li><span>✔</span> Ohne Installation via Browser unterschreiben</li>
        </ul>
        <p class="text-sm text-muted">(14 Tage unverbindlich – ohne Kreditkarte testen)</p>
        <div class="btn-group mt-1">
            <button class="btn btn-primary">Signaturen kostenlos testen →</button>
            <button class="btn btn-secondary">Features entdecken</button>
        </div>
    </div>
    <div class="hero-img">
        <img src="https://imzaflow.de/lovable-uploads/ee0ad821-6e87-47db-a6ea-2f8626de1636.png" alt="IMZAFLOW Plattform">
        <span class="badge badge-red badge-live">● Live</span>
    </div>
</section>

<!-- Lösung -->
<section id="loesung" class="section-light">
    <div class="container center">
        <h2 class="gradient-text">Digitaler Dokumentenaustausch mit imzaflow</h2>
        <p class="text-muted mb-3" style="max-width:700px;margin:1rem auto 0;"></p>
        <p class="text-muted" >Von der Einzelpraxis bis zum internationalen Team: Mit unserer Signatur-Lösung setzen Sie auf einen 100&nbsp;% digitalen Prozess, der Unterschriften einfach, schnell und absolut rechtssicher macht.</p>
    </div>

    <div class="features-grid container mt-1">
        <div class="card">
            <div class="icon-box">🛡</div>
            <h3>Rechtssichere eSignaturen</h3>
            <p>EU-weit gültige elektronische Signaturen nach eIDAS-Verordnung für alle Ihre Dokumente.</p>
        </div>
        <div class="card">
            <div class="icon-box">⚡</div>
            <h3>Blitzschnelle Umsetzung</h3>
            <p>In wenigen Minuten einsatzbereit – ohne komplexe IT-Integration oder Schulungsaufwand.</p>
        </div>
        <div class="card">
            <div class="icon-box">👥</div>
            <h3>Rollenbasierte Workflows</h3>
            <p>Alleine oder mit bis zu 10 Personen gemeinsam unterschreiben lassen.</p>
        </div>
    </div>
</section>

<!-- Vorteil -->
<section id="vorteil" class="section-white">
    <div class="container center">
        <h2 class="gradient-text mb-3">Messbare Erfolge</h2>

        <div class="flex items-center justify-center" style="flex-direction:column;gap:4rem;">
            <div>
                <div class="text-red" style="font-size:3.5rem;font-weight:800;">70%</div>
                <p style="font-weight:700;font-size:1.25rem;" class="mb-05">weniger Bearbeitungszeit</p>
                <p class="text-muted">durch intelligente Workflows</p>
            </div>
            <div>
                <div class="text-teal" style="font-size:3.5rem;font-weight:800;">100%</div>
                <p style="font-weight:700;font-size:1.25rem;" class="mb-05">eIDAS 2.0 konform</p>
                <p class="text-muted">Zukunftssicher und rechtsgültig</p>
            </div>
        </div>
    </div>
</section>

<!-- Fokus CTA -->
<section id="fokus" class="section-gradient">
    <div class="container">
        <h2 style="font-size:2.25rem;font-weight:800;" class="mb-1">Bereit für die digitale Zukunft?</h2>
        <p class="mb-25" style="margin:0 auto;max-width:650px;opacity:.9;font-size:1.1rem;">
            Starten Sie noch heute Ihren kostenlosen 14-Tage-Test.<br>
            Ohne Risiko, ohne Verpflichtungen.
        </p>
        <div class="btn-group justify-center">
            <button class="btn btn-light btn-lg">Jetzt 14 Tage testen →</button>
            <button class="btn btn-outline-white btn-md" (click)="navigate('', 'preise')">Preise ansehen</button>
        </div>
    </div>
</section>

<!-- Partner Logos -->
<section id="partner" class="section-white" style="padding:4rem 2rem;">
    <div class="container center">
        <h2 class="text-muted" style="font-size:1.25rem;letter-spacing:1px;text-transform:uppercase;" class="mb-3">
            Unsere Partner bei IMZAFLOW
        </h2>

        <div class="partner-grid">
            <div class="partner-card">
                <img src="partner-logos/wisekey.png" alt="Wisekey" class="partner-logo">
            </div>
            <div class="partner-card">
                <img src="partner-logos/namirial.png" alt="Namirial" class="partner-logo">
            </div>
            <div class="partner-card">
                <img src="partner-logos/sign8.png" alt="Sign8" class="partner-logo">
            </div>
            <div class="partner-card">
                <img src="partner-logos/lissi.png" alt="Lissi" class="partner-logo">
            </div>
            <div class="partner-card">
                <img src="partner-logos/dtrust.png" alt="D-Trust" class="partner-logo">
            </div>
            <div class="partner-card">
                <img src="partner-logos/ew-global.png" alt="ew global" class="partner-logo">
            </div>
        </div>
    </div>
</section>

<!-- Testphase -->
<section id="test" class="section-white">
    <div class="container center" style="max-width:950px;">
        <span class="badge badge-light-red mb-1">⏱ 14 Tage kostenlos testen</span>
        <h2 class="mb-05" style="font-size:2rem;font-weight:800;">
            Warum den <span class="text-red">kostenlosen Test</span> nutzen?
        </h2>
        <p class="text-muted mb-3" style="font-size:1.05rem;">
            Überzeugen Sie sich von der Einfachheit und Effizienz unserer Lösung.
            Kein Risiko, keine Verpflichtungen.
        </p>
    </div>

    <div class="features-grid container">
        <div class="card card-hover" style="text-align:left;cursor:pointer;">
            <div class="icon-box" style="background:#e0f2fe;color:#0369a1;">⏱</div>
            <h3>14 Tage vollumfänglich testen</h3>
            <p>Alle Premium-Features ohne Einschränkungen kostenlos nutzen.</p>
        </div>
        <div class="card card-hover" style="text-align:left;cursor:pointer;">
            <div class="icon-box" style="background:#f0f9ff;color:#0ea5e9;">👤</div>
            <h3>1 Benutzer inklusive</h3>
            <p>Testen Sie Workflows im Team ohne zusätzliche Kosten.</p>
        </div>
        <div class="card card-hover" style="text-align:left;cursor:pointer;">
            <div class="icon-box" style="background:#ecfdf5;color:#059669;">🖋</div>
            <h3>Elektronische Signaturen</h3>
            <p>Von anerkannten Trust Services bereitgestellt.</p>
        </div>
        <div class="card card-hover" style="text-align:left;cursor:pointer;">
            <div class="icon-box" style="background:#fef3c7;color:#d97706;">⚡</div>
            <h3>Sofort einsatzbereit</h3>
            <p>Setup in unter 2 Minuten, keine IT-Integration erforderlich.</p>
        </div>
        <div class="card card-hover" style="text-align:left;cursor:pointer;">
            <div class="icon-box" style="background:#ede9fe;color:#7c3aed;">🏅</div>
            <h3>Premium Support</h3>
            <p>Persönliche Betreuung während der gesamten Testphase.</p>
        </div>
        <div class="card card-hover" style="text-align:left;cursor:pointer;">
            <div class="icon-box" style="background:#dcfce7;color:#16a34a;">✔</div>
            <h3>Keine Verpflichtungen</h3>
            <p>Jederzeit kündbar, keine versteckten Kosten.</p>
        </div>
    </div>
</section>

<!-- Abschluss CTA -->
<section id="cta" class="section-white" style="padding:4rem 2rem;">
    <div class="container section-card">
        <h3 class="mb-1" style="font-size:1.75rem;font-weight:800;color:var(--color-dark);">
            Starten Sie noch heute Ihren kostenlosen Test
        </h3>
        <p class="text-muted mb-2" style="font-size:1.05rem;">
            In nur 2 Minuten registriert und sofort einsatzbereit.<br>
            Keine Kreditkarte erforderlich.
        </p>
        <button class="btn btn-primary" style="padding:1rem 2rem;font-size:1.1rem;">
            Jetzt 14 Tage kostenlos testen →
        </button>
    </div>
</section>

<!-- Fokus / USPs -->
<section id="fokus" class="section-white">
    <div class="container center" style="max-width:1000px;">
        <h2 class="gradient-text mb-1">Unsere USPs – worauf liegt unser Fokus?</h2>
        <p class="text-muted mb-3" style="font-size:1.05rem;">
            Was macht IMZAFLOW zur ersten Wahl für digitale Signaturen und Dokumentenmanagement?
        </p>
    </div>

    <div class="features-grid container">
        <div class="card card-hover" style="text-align:left;">
            <div class="icon-box" style="background:#ecfdf5;color:#059669;">🛡</div>
            <h3>Rechtssicherheit und Datenschutz</h3>
            <p><strong class="text-red">Deutsches Unternehmen</strong> mit Servern in Deutschland.
                <strong class="text-red">DSGVO-konforme</strong> Datenverarbeitung
                und höchste Datenschutzstandards für maximale Rechtssicherheit.</p>
        </div>

        <div class="card card-hover" style="text-align:left;">
            <div class="icon-box" style="background:#e0f2fe;color:#0369a1;">📋</div>
            <h3>Vollständige eIDAS-Compliance</h3>
            <p>Unterstützung aller drei Signaturarten:
                <span class="text-red">Einfache (SES)</span>,
                <span class="text-red">Fortgeschrittene (AES)</span>
                und <span class="text-red">Qualifizierte (QES)</span> nach EU-Standard.</p>
        </div>

        <div class="card card-hover" style="text-align:left;">
            <div class="icon-box" style="background:#fef3c7;color:#d97706;">⚙</div>
            <h3>Flexible Deployment-Optionen</h3>
            <p><span class="text-red">Cloud-Edition (SaaS)</span> für schnelle Bereitstellung
                oder <span class="text-red">Enterprise-Edition (On-Premise)</span>
                für vollständige Datenkontrolle – ganz nach Ihren Anforderungen.</p>
        </div>

        <div class="card card-hover" style="text-align:left;">
            <div class="icon-box" style="background:#e0f2fe;color:#0284c7;">🌐</div>
            <h3>Erweiterbares Digital-Ökosystem</h3>
            <p>Elektronische Signaturen als Kern mit ausbaufähigem
                <span class="text-red">DMS und Task-Management</span>.
                Modulare Plattform wächst mit Ihren Anforderungen.</p>
        </div>

        <div class="card card-hover" style="text-align:left;">
            <div class="icon-box" style="background:#ede9fe;color:#7c3aed;">⚡</div>
            <h3>API First Integration</h3>
            <p>Nahtlose Systemintegration durch modernen
                <span class="text-red">API First Ansatz</span>.
                Einfache Anbindung an bestehende ERP-, CRM- und Geschäftssysteme.</p>
        </div>

        <div class="card card-hover" style="text-align:left;">
            <div class="icon-box" style="background:#dcfce7;color:#16a34a;">🌍</div>
            <h3>Internationale Expansion geplant</h3>
            <p>Heute Deutschland-fokussiert,
                <span class="text-red">Ende 2025 Anbindung Türkei und Schweiz</span> geplant.
                Zukunftssichere Lösung für wachsende internationale Geschäftsbeziehungen.</p>
        </div>
    </div>
</section>

<!-- Sicherheit -->
<section id="security" class="section-light">
    <div class="container center" style="max-width:1000px;">
        <span class="badge badge-blue mb-1">Höchste Sicherheitsstandards</span>
        <h2 class="mb-05" style="font-size:2rem;font-weight:800;">
            Sicherheit von <span class="text-teal">staatlich geprüften Vertrauensdiensten</span>
        </h2>
        <p class="text-muted mb-3">Ihre sensiblen Dokumente sind bei uns in besten Händen.</p>
    </div>

    <div class="features-grid container">
        <div class="card card-hover" style="text-align:left;">
            <div class="icon-box" style="background:#ecfdf5;color:#059669;">🛡</div>
            <h3>eIDAS-konforme Signaturen</h3>
            <p>Qualifizierte elektronische Signaturen nach höchstem EU-Standard für maximale Rechtssicherheit.</p>
        </div>
        <div class="card card-hover" style="text-align:left;">
            <div class="icon-box" style="background:#e0f2fe;color:#0369a1;">🔒</div>
            <h3>Ende-zu-Ende Verschlüsselung</h3>
            <p>Alle Dokumente und Kommunikation werden mit modernster AES-256 Verschlüsselung geschützt.</p>
        </div>
        <div class="card card-hover" style="text-align:left;">
            <div class="icon-box" style="background:#fef3c7;color:#d97706;">📂</div>
            <h3>ISO 27001 zertifiziert</h3>
            <p>Höchste Sicherheitsstandards durch internationale Zertifizierung und regelmäßige Audits.</p>
        </div>
        <div class="card card-hover" style="text-align:left;">
            <div class="icon-box" style="background:#e0f2fe;color:#0284c7;">👁</div>
            <h3>DSGVO-konform</h3>
            <p>Vollständige Compliance mit europäischen Datenschutzbestimmungen. Made in Germany.</p>
        </div>
        <div class="card card-hover" style="text-align:left;">
            <div class="icon-box" style="background:#ede9fe;color:#7c3aed;">📋</div>
            <h3>Audit-Protokolle</h3>
            <p>Lückenlose Nachverfolgung aller Aktionen für Compliance und rechtliche Anforderungen.</p>
        </div>
        <div class="card card-hover" style="text-align:left;">
            <div class="icon-box" style="background:#dcfce7;color:#16a34a;">🏅</div>
            <h3>Qualifizierte Zeitstempel</h3>
            <p>Rechtssichere Zeitstempel für langfristige Archivierung und Beweiskraft von Dokumenten.</p>
        </div>
    </div>

    <div class="container mt-1">
        <div class="security-badges">
            <span>🇩🇪 Made in Germany</span>
            <span>🛡 ISO 27001 zertifiziert</span>
            <span>✅ DSGVO-konform</span>
            <span>🔒 eIDAS Level High</span>
        </div>
    </div>
</section>

<!-- Referenzen -->
<section id="referenzen" class="section-white">
    <div class="container center">
        <h2 class="gradient-text mb-05">Was unsere Kunden sagen</h2>
        <p class="text-muted mb-3">Verwaltungen und Unternehmen vertrauen auf IMZAFLOW</p>
    </div>

    <div class="features-grid container">
        <div class="card card-hover" style="text-align:left;">
            <div class="text-red" style="font-size:1.2rem;">★★★★★</div>
            <div class="text-teal" style="font-size:2rem;margin:.5rem 0;">❝</div>
            <blockquote style="font-style:italic;" class="mb-15">
                IMZAFLOW hat unsere Genehmigungsprozesse von 3 Wochen auf 2 Tage verkürzt. Unglaublich!
            </blockquote>
            <p><strong>Dr. Sarah Weber</strong><br>
                <span class="text-muted">Abteilungsleiterin Digitalisierung</span><br>
                <a href="#" class="link-teal">Stadtverwaltung München</a>
            </p>
        </div>

        <div class="card card-hover" style="text-align:left;">
            <div class="text-red" style="font-size:1.2rem;">★★★★★</div>
            <div class="text-teal" style="font-size:2rem;margin:.5rem 0;">❝</div>
            <blockquote style="font-style:italic;" class="mb-15">
                Die 14-Tage-Testphase hat uns sofort überzeugt. Einfacher geht digitale Signatur nicht.
            </blockquote>
            <p><strong>Michael Schmidt</strong><br>
                <span class="text-muted">IT-Leiter</span><br>
                <a href="#" class="link-teal">Kreisverwaltung Esslingen</a>
            </p>
        </div>

        <div class="card card-hover" style="text-align:left;">
            <div class="text-red" style="font-size:1.2rem;">★★★★★</div>
            <div class="text-teal" style="font-size:2rem;margin:.5rem 0;">❝</div>
            <blockquote style="font-style:italic;" class="mb-15">
                Endlich eine Lösung, die rechtssicher und gleichzeitig benutzerfreundlich ist. Top Support!
            </blockquote>
            <p><strong>Alexandra Müller</strong><br>
                <span class="text-muted">Geschäftsführerin</span><br>
                <a href="#" class="link-teal">Rechtsanwaltskanzlei Müller &amp; Partner</a>
            </p>
        </div>
    </div>
</section>

<!-- Preise -->
<section id="preise" class="section-white" style="padding:5rem 2rem;">
    <div class="container center">
        <h2 class="gradient-text mb-15">Pakete &amp; Preise</h2>

        <div class="toggle-wrapper mb-3">
            <button class="toggle-btn active" id="monthly">Monatlich</button>
            <button class="toggle-btn" id="yearly">Jährlich <span class="discount">-15%</span></button>
        </div>

        <div class="features-grid container" style="align-items:stretch;">
            <!-- Starter -->
            <div class="card price-card">
                <div>
                    <h3>Starter</h3>
                    <div class="price-label">14 Tage gratis</div>
                    <ul>
                        <li>✔ Testaccount</li>
                        <li>✔ 14 Tage unbegrenzte EES</li>
                        <li>✔ Visuelle Signatur erstellen</li>
                        <li>✔ Upgrade auf Basic oder Business möglich</li>
                    </ul>
                </div>
                <button class="btn btn-secondary">Jetzt starten</button>
            </div>

            <!-- Basic -->
            <div class="card price-card border-teal">
                <span class="badge-popular">Beliebt</span>
                <div>
                    <h3>Basic</h3>
                    <div class="price" id="price-basic">€8,50<span>/Monat</span></div>
                    <ul>
                        <li>✔ EES unbegrenzt</li>
                        <li>✔ EES+ (Organisationszertifikat) unbegrenzt</li>
                        <li>✔ Extern signieren ohne eigenen Account</li>
                        <li>✔ Upgrade auf Business möglich</li>
                    </ul>
                </div>
                <button class="btn btn-primary">Jetzt kaufen</button>
            </div>

            <!-- Business -->
            <div class="card price-card">
                <span class="badge-best">Beste Wahl</span>
                <div>
                    <h3>Business</h3>
                    <div class="price" id="price-business">€18,50<span>/Monat</span></div>
                    <ul>
                        <li>✔ EES unbegrenzt</li>
                        <li>✔ EES+ (Organisationszertifikat) unbegrenzt</li>
                        <li>✔ 5× eIDAS FES oder QES pro Monat inkl.</li>
                        <li>✔ Weitere Signaturen zubuchbar</li>
                        <li>✔ Jede weitere FES: 1,60 €</li>
                        <li>✔ Jede weitere QES: 3,80 €</li>
                    </ul>
                </div>
                <button class="btn btn-teal">Jetzt kaufen</button>
            </div>
        </div>
    </div>
</section>

<!-- Kontaktformular -->
<section id="kontakt" class="section-white" style="padding:5rem 2rem;">
    <div class="container contact-grid">
        <!-- Kontaktinformationen -->
        <div class="card contact-card">
            <h3 class="mb-15" style="font-weight:700;">Kontaktinformationen</h3>

            <div class="contact-info">
                <span class="contact-icon">📍</span>
                <div>
                    <strong>Adresse</strong><br>
                    IMZAFLOW UG (haftungsbeschränkt)<br>
                    Munscheidstraße 14<br>
                    45886 Gelsenkirchen<br>Deutschland
                </div>
            </div>

            <div class="contact-info">
                <span class="contact-icon">📞</span>
                <div>
                    <strong>Telefon</strong><br>
                    +49 2151 3874 852
                </div>
            </div>

            <div class="contact-info">
                <span class="contact-icon">✉️</span>
                <div>
                    <strong>E-Mail</strong><br>
                    <a href="mailto:info@imzaflow.com" class="link">info (at) imzaflow.com</a>
                </div>
            </div>

            <div class="contact-info mb-15">
                <span class="contact-icon">⏰</span>
                <div>
                    <strong>Geschäftszeiten</strong><br>
                    Montag – Freitag: 9:00 – 18:00 Uhr
                </div>
            </div>

            <hr class="mb-1">

            <h4 class="mb-1">Geschäftsführer</h4>
            <div class="contact-managers">
                <div class="manager">
                    <img src="https://imzaflow.de/lovable-uploads/07bffd12-6c70-4aca-bd9c-31163a072e74.png" alt="Andreas Vollmert">
                    <div>
                        <strong>Andreas Vollmert</strong><br>
                        <a href="#" class="link-teal text-sm">LinkedIn</a>
                    </div>
                </div>
                <div class="manager">
                    <img src="https://imzaflow.de/lovable-uploads/756a15b1-c369-4389-91f2-2204a163a5c4.png" alt="Udo Wichert">
                    <div>
                        <strong>Udo Wichert</strong><br>
                        <a href="#" class="link-teal text-sm">LinkedIn</a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Kontaktformular -->
        <div class="card contact-card">
            <h3 class="mb-1" style="font-weight:700;">Kontakt aufnehmen</h3>
            <p class="text-muted mb-15">Haben Sie Fragen zu unseren Lösungen? Wir helfen Ihnen gerne weiter.</p>

            <form>
                <label for="name" class="form-label">Name *</label>
                <input id="name" type="text" required class="form-field">

                <label for="email" class="form-label">E-Mail-Adresse *</label>
                <input id="email" type="email" required class="form-field">

                <label for="subject" class="form-label">Betreff *</label>
                <input id="subject" type="text" required class="form-field">

                <label for="message" class="form-label">Nachricht *</label>
                <textarea id="message" rows="5" required class="form-textarea"></textarea>

                <button type="submit" class="form-btn">✈ Nachricht senden</button>
                <p class="text-sm text-muted mt-1">* Pflichtfelder. Ihre Daten werden vertraulich behandelt und nicht an Dritte weitergegeben.</p>
            </form>
        </div>
    </div>
</section>

<footer>
    <div class="footer-inner">
        <div class="flex items-center gap-1">
            <img src="https://imzaflow.de/lovable-uploads/f6a771ae-6ce0-46a7-9854-a4ad61ca3ddc.png" alt="IMZAFLOW Logo" class="footer-logo">
        </div>
        <div class="footer-links">
            <span>© 2024 IMZAFLOW. Alle Rechte vorbehalten.</span>
            <a href="#" class="footer-link">Datenschutz</a>
            <a href="#" class="footer-link">Impressum</a>
        </div>
    </div>
</footer>

<script>
    // Preise Original
    const prices = {
        basic: 8.50,
        business: 18.50
    };

    // Elemente
    const btnMonthly = document.getElementById("monthly");
    const btnYearly = document.getElementById("yearly");
    const priceBasic = document.getElementById("price-basic");
    const priceBusiness = document.getElementById("price-business");

    // Monats-Preise setzen
    function setMonthly() {
        btnMonthly.classList.add("active");
        btnYearly.classList.remove("active");

        priceBasic.innerHTML = `€${prices.basic.toFixed(2).replace('.', ',')}<span>/Monat</span>`;
        priceBusiness.innerHTML = `€${prices.business.toFixed(2).replace('.', ',')}<span>/Monat</span>`;
    }

    // Jahres-Preise setzen (12 Monate -15%)
    function setYearly() {
        btnYearly.classList.add("active");
        btnMonthly.classList.remove("active");

        let yearlyBasic = prices.basic * 12 * 0.85;
        let yearlyBusiness = prices.business * 12 * 0.85;

        priceBasic.innerHTML = `€${yearlyBasic.toFixed(2).replace('.', ',')}<span>/Jahr</span>`;
        priceBusiness.innerHTML = `€${yearlyBusiness.toFixed(2).replace('.', ',')}<span>/Jahr</span>`;
    }

    // Events
    btnMonthly.addEventListener("click", setMonthly);
    btnYearly.addEventListener("click", setYearly);
</script>
